import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["tagName", "aria-level"];
import { Heading } from '../Heading/Heading';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export const H6 = _ref => {
  let {
      tagName = 'h6',
      'aria-level': ariaLevel = 2
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Heading, Object.assign({
    tagName: tagName,
    "aria-level": ariaLevel
  }, restProps, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'H6'
  }));
};
H6.displayName = 'H6';